import { Result } from "antd";
import React from "react";

const Page403 = () => {
  return <Result status="403" title="403" />;
};

export default Page403;
